<template>
  <form action="" class="proxy_apply login_same d-grid h-100 mb-0" autocomplete="off">
    <div class="login_wrap">
      <div class="login_toplogo d-flex align-items-center justify-content-between">
        <router-link to="/agent">
          <a class="btn btn_back d-flex rounded-circle border-0" href="#"><i class="icon-keyboard_arrow_left" /></a>
        </router-link>
        <img class="img_logo d-flex mw-100" :src="$store.getters.brand.image" height="50" alt="">
      </div>
      <div class="login_inner">
        <h5 class="login_title">
          {{ $t("Bao.member") }}{{ $t("Bao.apply_for_agent") }}
        </h5>
        <div class="login_form bank_area">
          <div class="form-group">
            <label class="form_lab"><b>{{ $t("Bao.apply_agent_input_contract") }}</b></label>
            <span class="position-relative">
              <select v-model="postForm.type" v-validate="'required'" class="account_form_slt w-100">
                <option value="">
                  {{ $t("Bao.apply_agent_choose_contract") }}
                </option>
                <option v-for="(item, key) in contactTypes" :key="key" :value="key">
                  {{ item }}
                </option>
              </select>
              <small class="help-block d-none">{{ $t("Bao.input_is_necessary") }}</small>
            </span>
          </div>
          <div class="form-group">
            <span class="position-relative">
              <input
                v-model="postForm.name"
                v-validate="'required'"
                class="account_form_ipt text-center w-100"
                :placeholder="$t('Bao.please_input')+(contactTypes[postForm.type] == undefined ? '' : contactTypes[postForm.type]) "
                name="contactName"
                :required="true"
                autocomplete="off"
              >
              <small v-if="errors.has('contactName')" class="help-block">{{ $t("Bao.input_is_necessary") }}</small>
            </span>
          </div>
          <div class="form-group">
            <div v-if="loginType=='phone'" class="form-group">
              <label class="form_lab">{{ $t('Bao.please_input') + $t("Bao.phone") }}</label>
              <vue-tel-input
                v-model="postForm.username"
                v-validate="'required'"
                class="form_ipt_tel"
                :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
                name="username"
                :data-vv-as="$t('Bao.phone')"
                :only-countries="countryList"
                :default-country="defaultCountry"
                mode="international"
                :required="true"
                autocomplete="off"
              />
              <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
            </div>
            <div v-else class="form-group">
              <label class="form_lab">{{ $t('Bao.please_input') + $t("Bao.username") }}</label>
              <input
                v-model="postForm.username"
                v-validate="'required'"
                class="account_form_ipt text-center w-100"
                :placeholder="$t('Bao.member_username_limit')"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.username')"
                autocomplete="off"
              >
              <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="form_lab">{{ $t('Bao.please_input') + $t("Bao.password") }}</label>
            <input
              v-model="postForm.password"
              v-validate="'required'"
              class="account_form_ipt text-center w-100"
              :placeholder="$t('Bao.password_notice')"
              :type="fieldTypes.password"
              name="password"
              :data-vv-as="$t('Bao.password')"
              autocomplete="off"
              @focus="handleType"
              @blur="handleType"
            >
            <small v-if="errors.has('password')" class="help-block">{{ errors.first('password') }}</small>
          </div>
          <div class="form-group mt-40 mb-30">
            <div class="proxy_apply_btn d-flex">
              <button v-if="loginType=='username'" class="btn btn_login_other d-flex align-items-center justify-content-center w-100" type="button" @click="changeLoginType()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15.889" height="22" viewBox="0 0 15.889 22">
                  <path d="M317.444,257h11a2.444,2.444,0,0,1,2.444,2.444v17.111A2.444,2.444,0,0,1,328.444,279h-11A2.444,2.444,0,0,1,315,276.556V259.444A2.444,2.444,0,0,1,317.444,257Zm.18,1.22h10.62a1.528,1.528,0,0,1,1.528,1.528v16.408a1.528,1.528,0,0,1-1.528,1.528h-10.62a1.528,1.528,0,0,1-1.528-1.528V259.748A1.528,1.528,0,0,1,317.625,258.22Zm5.32.613a.611.611,0,1,1-.611.611A.611.611,0,0,1,322.944,258.833Zm-6.679,1.681h13.4v.935h-13.4Zm0,14.647h13.4v.936h-13.4v-.935Z" transform="translate(-315 -257)" fill="#363636" fill-rule="evenodd" />
                </svg>
                <span>{{ $t("Bao.apply_by_phone") }}</span>
              </button>
              <button v-if="loginType=='phone'" class="btn btn_login_other d-flex align-items-center justify-content-center w-100" type="button" @click="changeLoginType()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15.889" height="22" viewBox="0 0 15.889 22">
                  <path d="M317.444,257h11a2.444,2.444,0,0,1,2.444,2.444v17.111A2.444,2.444,0,0,1,328.444,279h-11A2.444,2.444,0,0,1,315,276.556V259.444A2.444,2.444,0,0,1,317.444,257Zm.18,1.22h10.62a1.528,1.528,0,0,1,1.528,1.528v16.408a1.528,1.528,0,0,1-1.528,1.528h-10.62a1.528,1.528,0,0,1-1.528-1.528V259.748A1.528,1.528,0,0,1,317.625,258.22Zm5.32.613a.611.611,0,1,1-.611.611A.611.611,0,0,1,322.944,258.833Zm-6.679,1.681h13.4v.935h-13.4Zm0,14.647h13.4v.936h-13.4v-.935Z" transform="translate(-315 -257)" fill="#363636" fill-rule="evenodd" />
                </svg>
                <span>{{ $t("Bao.apply_by_username") }}</span>
              </button>
              <button
                type="button"
                class="btn btn_login w-100"
                :disabled="actionLoading"
                @click="handleUpdate"
              >
                {{ $t("Bao.confirm") }}
                <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
              </button>
            </div>
          </div>
          <div class="form-group mb-0">
            <div class="d-flex justify-content-center">
              <router-link to="/agent/new-member">
                <a class="login_forget d-block" href="#">
                  {{ $t("Bao.new_member_apply") }}
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login_bg" :style="{ backgroundImage: `url(${login_bg})` }" />
  </form>
</template>
<script>
import { VueTelInput } from 'vue-tel-input'
import { applyAgent } from '@/api/user'
import { showNotice } from '@/utils/tool'

export default {
  components: {
    VueTelInput
  },
  data() {
    const postForm = {
      username: null,
      password: null,
      type: '',
      name: ''
    }
    return {
      actionLoading: false,
      loginType: 'username',
      postForm,
      countryList: [],
      defaultCountry: '',
      fieldTypes: {
        password: 'text'
      },
      contactTypes: {
        'Telegram': 'Telegram',
        'e-mail': 'e-mail',
        'Facebook': 'Facebook',
        'phone_number': 'Phone Number'
      },
      login_bg: this.$store.state.brand.brandImage.agent_login_banner !== undefined ? this.$store.state.brand.brandImage.agent_login_banner[0].image : ''
    }
  },
  created() {
    if (this.$route.query.login_type !== undefined) {
      this.loginType = this.$route.query.login_type
    }

    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    handleReset() {
      this.postForm = Object.assign({}, this.defaultForm)
    },
    handleUpdate() {
      const self = this
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          applyAgent(this.postForm).then(response => {
            showNotice(response.data.data.msg, function() {
              self.$router.push({ path: '/index' })
            })
          }).catch((error) => {
            showNotice(error.response.data.msg)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    },
    changeLoginType() {
      if (this.loginType === 'username') {
        this.loginType = 'phone'
      } else {
        this.loginType = 'username'
      }
    },
    handleType(event) {
      const { srcElement, type } = event
      const { name, value } = srcElement

      if (type === 'blur' && !value) {
        this.fieldTypes[name] = 'text'
      } else {
        this.fieldTypes[name] = 'password'
      }
    }
  }
}
</script>

<style scoped>
  .verify-button {
    text-align: center;
    border-radius: 4.8vw;
    background-color: #181c2e;
    border: 1px solid #0bd664;
    padding: 4px 6px;
    color: #adadad;
    cursor: pointer;
  }

  .verify-success {
    color: #0cd664;
    border: 0px;
    background-color: #181c2e;
  }
  .form_ipt_tel :focus{
    outline: none;
    border: 2px solid #9aeeaa;
  }
</style>
